/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import { Icon, Card } from "@mui/material";
// import Divider from "@mui/material/Divider";
// import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function BalanceOverviewCard({ idx, color, icon, symbol, amount, title }) {
  // const x = currencyCode !== "N/A" ? currencyCode : undefined;
  // const formatter = new Intl.NumberFormat(x, {
  //   style: "currency",
  //   currency: x !== undefined ? currencyCode : "NGN",

  //   // These options are needed to round to whole numbers if that's what you want.
  //   // minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //   maximumFractionDigits: 2, // (causes 2500.99 to be printed as $2,501)
  // });

  function format(amt) {
    return `${symbol}${amt.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }

  return (
    <Card>
      <MDBox display="flex" justifyContent="space-between" pt={1} px={2}>
        <MDBox
          key={idx}
          variant="gradient"
          bgColor={color}
          color={color === "light" ? "dark" : "white"}
          coloredShadow={color}
          borderRadius="xl"
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="4rem"
          height="4rem"
          mt={-3}
        >
          <Icon>{icon}</Icon>
        </MDBox>
        <MDBox textAlign="right" lineHeight={1.25} sx={{ mb: 3 }}>
          <MDTypography variant="button" fontWeight="light" color="text">
            {title}
          </MDTypography>
          <MDTypography variant="h4">{format(amount / 100)}</MDTypography>
        </MDBox>
      </MDBox>
    </Card>
  );
}

// Setting default values for the props of ComplexStatisticsCard
BalanceOverviewCard.defaultProps = {
  color: "info",
  icon: "chevron_right",
  // currencyCode: "N/A",
  symbol: "",
  amount: "0.00",
  idx: "1",
  title: "---",
};

// Typechecking props for the ComplexStatisticsCard
BalanceOverviewCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  title: PropTypes.string,
  idx: PropTypes.string,
  icon: PropTypes.string,
  // currencyCode: PropTypes.string,
  symbol: PropTypes.string,
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default BalanceOverviewCard;
